<template>
    <div
        ref="collapse"
        :class="['custom-collapse', { show: isOpen }]"
        :style="collapseStyle"
    >
        <div ref="content" class="collapse-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "CustomCollapse",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        accordion: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isOpen: this.visible,
            height: 0,
            isAnimating: false
        };
    },
    computed: {
        collapseStyle() {
            if (this.isAnimating) {
                return {
                    height: this.height + "px",
                    overflow: "hidden"
                };
            }

            if (this.isOpen) {
                return {
                    height: "auto",
                    overflow: "visible"
                };
            }

            return {
                height: "0px",
                overflow: "hidden"
            };
        }
    },
    watch: {
        visible(newVal) {
            if (newVal !== this.isOpen) {
                this.toggle(newVal);
            }
        }
    },
    mounted() {
        if (this.isOpen) {
            this.height = this.$refs.content.scrollHeight;
        }
    },
    methods: {
        toggle(show = null) {
            const shouldShow = show !== null ? show : !this.isOpen;

            if (shouldShow === this.isOpen) return;

            this.isAnimating = true;

            if (shouldShow) {
                this.show();
            } else {
                this.hide();
            }
        },
        show() {
            // Get the natural height
            const contentHeight = this.$refs.content.scrollHeight;

            // Start from 0
            this.height = 0;
            this.isOpen = false;

            // Force reflow
            this.$refs.collapse.offsetHeight;

            // Animate to full height
            this.$nextTick(() => {
                this.height = contentHeight;

                // After animation completes
                setTimeout(() => {
                    this.isOpen = true;
                    this.isAnimating = false;
                    this.$emit("shown");
                }, 350); // Match CSS transition duration
            });

            this.$emit("show");
        },
        hide() {
            // Get current height
            const contentHeight = this.$refs.content.scrollHeight;
            this.height = contentHeight;

            // Force reflow
            this.$refs.collapse.offsetHeight;

            // Animate to 0
            this.$nextTick(() => {
                this.height = 0;

                // After animation completes
                setTimeout(() => {
                    this.isOpen = false;
                    this.isAnimating = false;
                    this.$emit("hidden");
                }, 350); // Match CSS transition duration
            });

            this.$emit("hide");
        }
    }
};
</script>

<style scoped>
.custom-collapse {
    transition: height 0.35s ease;
}
</style>
